import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Table, Spinner, Stack } from "react-bootstrap";
import { uniqueId } from "lodash";
import styles from "./styles/TableCustom.module.css";
import { NoData } from "../NoData/NoData";

const TableCustom = (props) => {
  const { columns, indexing, dataSource, isLoading, className, ...restProps } =
    props;

  return (
    <>
      <Table
        className={clsx(styles.tableContainer, className)}
        responsive
        {...restProps}
      >
        <thead>
          <tr>
            {indexing ? <th>#</th> : null}
            {columns.map((col) => {
              if (col.isSortable) {
                return (
                  <th key={uniqueId()} onClick={col.onSorting}>
                    {col.title}
                  </th>
                );
              }
              return <th key={uniqueId()}>{col.title}</th>;
            })}
          </tr>
        </thead>

        <tbody className="w-100">
          {!isLoading
            ? dataSource.map((val, index) => {
                return (
                  <tr key={uniqueId()} className="table-tr">
                    {indexing ? <td>{index + 1}</td> : null}
                    {columns.map((col) => {
                      if (col.render) {
                        return (
                          <td key={uniqueId()} style={{ whiteSpace: "nowrap" }}>
                            {/* {col.render(val[col.dataIndex])} */}
                            {col.render(val[col.dataIndex], val)}
                          </td>
                        );
                      }
                      return <td key={uniqueId()}>{val[col.dataIndex]}</td>;
                    })}
                  </tr>
                );
              })
            : null}
        </tbody>
      </Table>
      {!isLoading && dataSource.length === 0 ? (
        <NoData className={"bg-transparent border-0 p-0 m-0"} />
      ) : null}
      {isLoading ? (
        <Stack className="align-items-center p-5 m-5" gap={2}>
          <Spinner animation="border" variant="danger" />
          <span className="ml-2 text-danger">Loading data...</span>
        </Stack>
      ) : null}
    </>
  );
};

/* required: display name */
TableCustom.displayName = "TableCustom";

/* required: props types */
TableCustom.propTypes = {
  columns: PropTypes.array,
  dataSource: PropTypes.array,
  isLoading: PropTypes.bool,
  indexing: PropTypes.bool,
};

/* required: default props */
TableCustom.defaultProps = {
  columns: [],
  dataSource: [],
  isLoading: false,
  indexing: false,
};

export { TableCustom };
